import { Column, getColumns } from '../../../../utility/decorator/entity/column.decorator';
import { KnowledgeActivityId, KnowledgeActivityTargetType, KnowledgeActivityType } from '../value';

import { AccountOrganizationId } from '../../account/value';
import { Entity } from '../../../../utility/model/entity.model';
import { IsDeleted } from '../../base/value';
import { PostId } from '../../../kernel/post';
import { Timestamp } from '../../../../utility/model/timestamp.value';

export class KnowledgeActivity implements Entity {
  @Column()
  readonly id: KnowledgeActivityId;
  @Column()
  postId: PostId;
  @Column()
  targetType: KnowledgeActivityTargetType;
  @Column()
  type: KnowledgeActivityType;
  @Column()
  actionBy: AccountOrganizationId;
  @Column()
  createdAt: Timestamp;
  @Column()
  updatedAt: Timestamp;
  @Column()
  isDeleted: IsDeleted;

  constructor(id: KnowledgeActivityId) {
    this.id = id;
  }

  static get allFields(): (keyof KnowledgeActivity)[] {
    return getColumns(new KnowledgeActivity(KnowledgeActivityId.create('')));
  }

  equals(value: KnowledgeActivity): boolean {
    return this.id.equals(value.id);
  }
}
